module.exports = __webpack_public_path__ + "shanz/static/media/menarabic22.5962e7bf.png";